import Vue from "vue";
import Router from "vue-router";
import Home from "./components/Home.vue"
import Login_old from "./components/Login_old.vue"
import Register from "./components/Register.vue"
import { getLoggedInUser, getUsersProject, PROJECTS } from "./constants/role.js"

import Dashboard from "./components/Dashboard.vue"

import NotFound from "./components/NotFound.vue"
import MyDashboard from "./components/welcome.vue"
import mastersTable from "./components/mastersTable.vue" 

// import accidentManagement from "./components/accidentManagement.vue" 
// import breakdownManagement from "./components/breakdownManagement.vue"
// import listingDetails from "./components/listingDetails.vue"
import googleMap from "./components/googleMap.vue" 
import trackingDashboard from "./components/trackingDashboard.vue" 
import DailyTransaction from "./components/DailyTransaction.vue"
import MasterCreate from "./components/masterCreate.vue"
import GateEntry from "./components/GateEntry.vue"
import GateInOutAnalysis from "./components/reports/GateInOutAnalysis.vue"
import DockInOutAnalysis from "./components/reports/DockInOutAnalysis.vue"
import VehicleAllocationAnalysis from "./components/reports/VehicleAllocationAnalysis.vue"
import CrossDockPerformance from "./components/reports/crossDockPerformance.vue"
import PalletScans from "./components/reports/PalletScans.vue"
import OutboundPlanView from "./components/OutboundPlan.vue"
import InboundPlanView from "./components/InboundPlan.vue"
import ToliLevelProductivity from "./components/reports/ToliLevelProductivity.vue"
import Vcalendar from "./components/VehicleCalendar.vue"
import MapRoutes from "./components/reports/MapRoutes.vue"
import MapCluster from "./components/reports/MapCluster.vue"
import MapClustFin from "./components/reports/MapClustFin.vue"
import dockSummaryView from "./components/dockSummary.vue"
import dockSummaryView2 from "./components/dockSummaryView2.vue"
import unloadingSummaryView from "./components/unloadingSummaryView.vue"
import MarkerClustering from "./components/MarkerClustering.vue"
import mapRoutes from "./components/mapRoutes.vue"
import DockReport from "./components/reports/DockReport.vue"
import GlobalSearch from "./components/GlobalSearch.vue"
import routeTraking from "./components/routeTraking.vue"
import fleetDashboard from "./components/fleetDashboard.vue"
import IncentiveGrid from "./components/reports/Incentive.vue"
import escalationConfiguration from "./components/escalationConfiguration.vue"
import VehicleScheduling from "./components/VehicleScheduling.vue"

// Support routes
import AddTicket from "./components/support/tickets/AddTicket.vue"
import TicketConfiguration from "./components/support/tickets/TicketConfiguration.vue"
import TicketRoadster from "./components/support/tickets/TicketRoadster.vue"
import Ticket from "./components/support/tickets/Ticket.vue"
import TicketDetails from "./components/support/tickets/TicketDetails.vue"

// attendacne
import AttendanceRegularise from "./components/attendance/AttendanceRegularise.vue"
import LeaveApply from "./components/attendance/LeaveApply.vue"

import callingDashboard from "./components/callingDashboard.vue" 
import controlltower from "./components/controlltower.vue"

// COntrol towerr
import MyControlTowerDashboard from "./components/controlTower/Dashboard.vue"
import AdminPanel from "./components/controlTower/AdminPanel.vue";
import accidentManagement from "./components/controlTower/accidentManagement.vue" 
import accidentDetails from "./components/controlTower/accidentDetails.vue"
import breakdownManagement from "./components/controlTower/breakdownManagement.vue"
import editAccident from "./components/controlTower/editAccident.vue"
import editBreakdown from "./components/controlTower/editBreakdown.vue";
import breakdownDetails from "./components/controlTower/breakdownDetails.vue"
import escalationCallDetails from "./components/controlTower/escalationCallDetails.vue"
import stcContactForm from "./components/controlTower/stcContactForm.vue"
import stcContactList  from "./components/controlTower/stcContactList.vue";
import vehicleGeoLocation from "./components/controlTower/vehicleGeoLocation.vue"
import routeperformance from "./components/controlTower/RoutePerformance.vue"
import enroutedelay from "./components/controlTower/enroutedelay.vue"
import accidentreport from "./components/controlTower/accidentreport.vue"
import listingDetails from "./components/controlTower/listingDetails.vue"
import RBAC from "./components/controlTower/RBAC.vue"
Vue.use(Router)

const router= new Router({
    mode:'hash',
    routes:[
        {
            path:'/',
            redirect: '/mydashboard',
        },
        {
            path:'/login',
            name: "Login_old",
            component: Login_old
        },   
        {
            path: '/home',
            component: Home,
            children: [
                {
                    path:'/register',
                    name: "Register",
                    component: Register
                },
                {
                    path:'/mydashboard',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path:'/master',
                    name:'mastersTable',
                    component:mastersTable
                },
                {
                    path:'/accident-management',
                    name:'accidentManagement',
                    component:accidentManagement
                },
                {
                    path:'/accident-reports',
                    name:'accidentDetails',
                    component: accidentDetails,
                    meta: { requiresAuthorization: true }
                },
                {
                    path:'/breakdown-reports',
                    name:'breakdownDetails',
                    component: breakdownDetails
                },
                {
                    path:'/breakdown-management',
                    name:'breakdownManagement',
                    component: breakdownManagement
                },
                {
                    path:'/vehicle-tracking',
                    name:'listingDetails',
                    component:listingDetails
                },
                {
                    path:'/google-map',
                    name:'googleMap',
                    component:googleMap
                }, 
                {
                    path:'/tracking-dashboard',
                    name:'trackingDashboard',
                    component:trackingDashboard
                },
                {
                    path:'/calling-dashboard',
                    name:'callingDashboard',
                    component:callingDashboard
                },
                {
                    path:'/entry/daily-transaction',
                    name:'DailyTransaction',
                    component:DailyTransaction
                },
                {
                    path:'/entry/dock-control',
                    name:'MasterCreate',
                    component:MasterCreate
                },
                {
                    path:'/entry/gate-control',
                    name:'GateEntry',
                    component:GateEntry
                },
                {
                    path:'/reports/analysis/gate-in-out',
                    name:'GateInOutAnalysis',
                    component:GateInOutAnalysis
                },
                {
                    path:'/reports/analysis/incentive',
                    name:'IncentiveGrid',
                    component:IncentiveGrid
                },
                {
                    path:'/reports/analysis/dock-in-out',
                    name:'DockInOutAnalysis',
                    component:DockInOutAnalysis
                },
                {
                    path:'/reports/analysis/dockreport',
                    name:'DockReport',
                    component:DockReport
                },
                {
                    path:'/reports/analysis/vehicle-allocations',
                    name:'VehicleAllocationAnalysis',
                    component: VehicleAllocationAnalysis
                },
                {
                    path:'/reports/analysis/pallet-scans',
                    name:'PalletScans',
                    component: PalletScans
                },
                {
                    path:'/reports/analysis/toli-level-productivity',
                    name:'ToliLevelProductivity',
                    component: ToliLevelProductivity
                },
                {
                    path:'/reports/analysis/map-routes',
                    name:'MapRoutes',
                    component: MapRoutes
                },
                {
                    path:'/reports/analysis/map-cluster',
                    name:'MapCluster',
                    component: MapCluster
                },
                {
                    path:'/reports/analysis/map-cluster-final',
                    name:'MapClustFin',
                    component: MapClustFin
                },
                {
                    path:'/reports/analysis/gate-dock-performance',
                    name:'CrossDockPerformance',
                    component: CrossDockPerformance
                },
                {
                    path:'/outbound/floor-plan-view',
                    name:'OutboundPlanView',
                    component:OutboundPlanView
                },
                {
                    path:'/inbound/floor-plan-view',
                    name:'OutboundPlanView',
                    component: InboundPlanView
                },
                {
                    path:'/schedules/vehicle-calendar',
                    name:'Vcalendar',
                    component:Vcalendar
                },
                {
                    path:'/live/dockSummaryView',
                    name:'dockSummaryView2',
                    component:dockSummaryView2
                },
                {
                    path:'/live/unloadingSummaryView',
                    name:'unloadingSummaryView',
                    component:unloadingSummaryView
                },
                {
                    path:'/live/vehicle/map-cluster',
                    name:'MarkerClustering',
                    component: MarkerClustering
                },
                {
                    path:'/live/vehicle/routes',
                    name:'mapRoutes',
                    component: mapRoutes
                },
                {
                    path: '/search-details',
                    name: 'GlobalSearch',
                    component: GlobalSearch
                },
                {
                    path: '/route-traking',
                    name: 'routeTraking',
                    component: routeTraking
                },
                {
                    path: '/fleet-dashboard',
                    name: 'fleetDashboard',
                    component: fleetDashboard
                },
                {
                    path: '/support/tickets/add-ticket',
                    name: 'AddTicket',
                    component: AddTicket
                },
                {
                    path: '/support/tickets/add-ticket-configuration',
                    name: 'TicketConfiguration',
                    component: TicketConfiguration
                },
                {
                    path: '/support/tickets/add-ticket-roadster',
                    name: 'TicketRoadster',
                    component: TicketRoadster
                },
                {
                    path: '/support/tickets/:id',
                    name: 'TicketDetails',
                    component: TicketDetails
                },
                {
                    path: '/support/tickets',
                    name: 'Ticket',
                    component: Ticket
                }, 
                {
                    path: '/attendance/attendance-regularise',
                    name: 'AttendanceRegularise',
                    component: AttendanceRegularise
                }, 
                {
                    path: '/attendance/leave-apply',
                    name: 'LeaveApply',
                    component: LeaveApply
                }, 
                {
                    path: '/escalation-configuration',
                    name: 'escalationConfiguration',
                    component: escalationConfiguration
                },
                {
                    path: '/vehicle/scheduling',
                    name: 'VehicleScheduling',
                    component: VehicleScheduling
                },
                {
                    path: '/controlltower',
                    name: 'controlltower',
                    component: controlltower
                },
                {
                    path: '/admin-panel',
                    name: 'AdminPanel',
                    component: AdminPanel
                },
                {
                    path:'/escalation/escalated-calls',
                    name:'escalationcalldetails',
                    component:escalationCallDetails,
                    meta: { requiresAuthorization: true }
                },
                {
                    path:'/escalation/stcform',
                    name:'escalationStcForm',
                    component:stcContactForm,
                    meta: { requiresAuthorization: true }   
                },
                {
                    path:'/escalation/stc-contacts',
                    name:'stccontactlist',
                    component:stcContactList,
                    meta: { requiresAuthorization: true }
                    
                },
                {
                    path:'/escalation/vehicle-geolocation',
                    name:'vehicleGeolocation',
                    component:vehicleGeoLocation,
                    meta: { requiresAuthorization: true }
                },
                {
                    path:'/reports/routeperformance',
                    name:'routeperformance',
                    component:routeperformance,
                    meta: { requiresAuthorization: true }
                },
                {
                    path:'/reports/enroutedelay',
                    name:'enroutedelay',
                    component:enroutedelay,
                    meta: { requiresAuthorization: true }
                },
                {
                    path:'/reports/accidentreport',
                    name:'accidentreport',
                    component:accidentreport,
                    meta: { requiresAuthorization: true }
                },
                {
                    path:'/editaccident/:id',
                    name:'editAccident',
                    component:editAccident,
                },
                {
                    path:'/editbreakdown/:id',
                    name:'editBreakdown',
                    component:editBreakdown,
                },
                {   
                    path:'/access-control',
                    name:'RBAC',
                    component: RBAC,
                    meta: { requiresAuthorization: true }
                },
                {
                    path:'/*',
                    name: 'NotFound',
                    component: NotFound,
                },
            ]
        } 
    ]
});


router.beforeEach((to, from, next) => {
    let isUserAuthenticated = window.localStorage.getItem('userdata');
    if (to.name === 'Login_old' && isUserAuthenticated) {
        next({ path: '/mydashboard' })
    } else if (isUserAuthenticated) {
        next()
    } else {
        next()
    }
})

export default router